// extracted by mini-css-extract-plugin
export default {"otpContainer":"OtpFields_otpContainer__AZpjX","otpInput":"OtpFields_otpInput__Whfux"};